module.exports = __webpack_public_path__ + "static/img/Isaiah-Papali’i.21e6571.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Isaiah-Papali’i.jpg
// module id = hYUN
// module chunks = 0